import React, { useCallback, useMemo } from 'react';

// Utils
import { useRouter } from 'next/router';
import bookingStep from '../../../../src/enum/bookingStep';

import styles from './MobileStepper.module.scss';
import { useAppContext } from '../../../../src/store/AppContext';

function MobileStepper() {
  const router = useRouter();
  const { pathname } = router;
  const { stepFromPath } = bookingStep;

  const [{ currentPlayer, players }] = useAppContext();
  const currentPlayerId = useMemo(() => (currentPlayer?.id || 1), [currentPlayer]);
  const playersCount = useMemo(() => players?.length, [players]);

  const getProgress = useCallback(() => {
    if (!playersCount) return null;

    // 3 steps for each player (camp, options and summary)
    // and then 4 steps for everyone (accommodations, attribution, billing and payment)
    // and add 1 to keep uncomplete step at the end before payment
    const target = (3 * playersCount) + 4 + 1;
    let progress = 0;

    switch (stepFromPath[pathname]) {
      case 'stage': {
        progress = ((currentPlayerId - 1) * 3) + 1;
        break;
      }
      case 'options': {
        progress = ((currentPlayerId - 1) * 3) + 2;
        break;
      }
      case 'summary': {
        progress = ((currentPlayerId - 1) * 3) + 3;
        break;
      }
      case 'hosting':
        progress = (playersCount * 3) + 1;
        break;
      case 'assignment':
        progress = (playersCount * 3) + 2;
        break;
      case 'billing':
        progress = (playersCount * 3) + 3;
        break;
      case 'payment':
        progress = (playersCount * 3) + 4;
        break;
      default:
        break;
    }

    return (100 * (progress)) / target;
  }, [pathname]);

  return getProgress() ? (
    <div className={styles.stepper}>
      <span className={styles.progress} style={{ width: `${getProgress()}%` }} />
    </div>
  ) : null;
}

MobileStepper.propTypes = {};

export default MobileStepper;
